/*
 * @Author: ezhizao 庄德政
 * @LastEditors: ezhizao 庄德政
 * @Description: 
 */
const RootPath = window.g.baseUrl
const apis = {
  /* 设备 */
  getEquipments: RootPath + 'Plugin/user/website/equipment/index',
  getEquipment: RootPath + 'Plugin/user/website/equipment/getForm',
  saveEquipment: RootPath + 'Plugin/user/website/equipment/save',
  delEquipments: RootPath + 'Plugin/user/website/equipment/delete',
  /* 设备类别 */
  getEquipmentCategories: RootPath + 'Plugin/user/website/equipment/getCategoryList',
  getEquipmentCategory: RootPath + 'Plugin/user/website/equipment/getCategoryForm',
  saveEquipmentCategory: RootPath + 'Plugin/user/website/equipment/saveCategory',
  delEquipmentCategories: RootPath + 'Plugin/user/website/equipment/delCategories'

}

export default apis